import { getLangNameFromCode as baseGetLangNameFromCode } from 'language-name-map';

import { Nullable, CourseStep } from 'types';

export const joinStrings = (
  values: Nullable<string>[],
  separator: string,
  placeholder: string | null = '-'
): string => {
  const data = values.filter((value) => value && value?.length > 0) as string[];
  return data.length === 0 ? (placeholder ?? '') : data.join(separator);
};

type Language = { name: string; native: string; dir: 'ltr' | 'rtl' };

export const getLangNameFromCode = (langCode: string): Language | undefined =>
  baseGetLangNameFromCode(langCode);

export const getStepTitle = (step: CourseStep, language?: string) =>
  (language && step?.translations?.[language]?.name) || step?.name;

export const clearCacheAndReload = async () => {
  const keyList = await caches.keys();
  await Promise.all(keyList.map((key) => caches.delete(key)));

  window.location.reload();
};

export const getWistiaId = (videoUrl: string): string | undefined =>
  videoUrl.match(/wistia\.com\/medias\/([a-z0-9]+)/i)?.[1];
